import { LateFeeConfigurationModel, CreateLateFeeConfigurationRequest } from '../models/data/property-charge-schedule.model';
import { LateFeeOccurrenceType, LateFeeTierUiModel } from '../models/ui/late-fee-config.model';

export class LateFeeUtilities {

    public static buildLateFeeApiConfigurations(
        tiers: LateFeeTierUiModel[]
    ): CreateLateFeeConfigurationRequest[] {
        return tiers.map(tier => {
            const gracePeriodDays = Math.max(0, Math.floor(tier.gracePeriodDays || 0));

            let occurrences: number | undefined;
            let frequencyDays: number | undefined;

            switch (tier.occurrenceType) {
                case 'Once':
                    occurrences = 1;
                    frequencyDays = undefined;
                    break;
                case 'Multiple':
                    occurrences = tier.multipleCount && tier.multipleCount > 1
                        ? Math.floor(tier.multipleCount)
                        : 2;
                    frequencyDays = tier.frequencyDays && tier.frequencyDays > 0
                        ? Math.floor(tier.frequencyDays)
                        : 1;
                    break;
                case 'UntilPaid':
                    occurrences = undefined;
                    frequencyDays = tier.frequencyDays && tier.frequencyDays > 0
                        ? Math.floor(tier.frequencyDays)
                        : 1;
                    break;
            }

            return {
                feeAmount: tier.amount,
                gracePeriodDays,
                occurrences,
                frequencyDays,
            };
        });
    }

    public static parseLateFeeApiConfigurations(
        configs: LateFeeConfigurationModel[] | undefined
    ): LateFeeTierUiModel[] {
        if (!configs || configs.length === 0) {
            return [];
        }

        return configs.map(config => {
            const occurrenceType = LateFeeUtilities.deriveOccurrenceType(config.occurrences);

            return {
                amount: config.feeAmount,
                gracePeriodDays: config.gracePeriodDays ?? 0,
                occurrenceType,
                multipleCount: occurrenceType === 'Multiple' ? config.occurrences : undefined,
                frequencyDays: occurrenceType === 'Once' ? undefined : config.frequencyDays,
            };
        });
    }

    private static deriveOccurrenceType(occurrences: number | null | undefined): LateFeeOccurrenceType {
        if (occurrences === null || occurrences === undefined) return 'UntilPaid';
        if (occurrences <= 1) return 'Once';
        return 'Multiple';
    }
}
